import { render, staticRenderFns } from "./ReferenceLetterDocuments.vue?vue&type=template&id=f09a44b8&scoped=true"
import script from "./ReferenceLetterDocuments.vue?vue&type=script&lang=js"
export * from "./ReferenceLetterDocuments.vue?vue&type=script&lang=js"
import style0 from "./ReferenceLetterDocuments.vue?vue&type=style&index=0&id=f09a44b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09a44b8",
  null
  
)

export default component.exports